import { Fragment } from 'react';
import { NextPage } from 'next';

import { field, useForm, useSubmit, validate } from '@reckon-web/forms';
import { Flex } from '@reckon-web/flex';
import { Text } from '@reckon-web/text';
import { Button } from '@reckon-web/button';
import { Box } from '@reckon-web/box';
import { Heading } from '@reckon-web/heading';

import { TextField } from '../generic/TextField';

export const VerifyCodeForm: NextPage<{
  sendCode: any;
  verifyCode?: any;
  setErrorMessage?: any;
  children?: any;
}> = ({ sendCode, verifyCode, setErrorMessage, children }) => {
  let mfaForm = field.object({
    code: field.text({
      validate: validate((value) => {
        if (!value.length) return validate.error('Enter the code');
        return value;
      }),
    }),
  });

  let form = useForm(mfaForm);
  const submit = useSubmit(form, async (value) => verifyCode(value.code));
  return (
    <Fragment>
      <form
        id="mfa-form"
        onChange={() => setErrorMessage('')}
        onSubmit={submit}
      >
        <Flex
          direction="column"
          gap="medium"
          alignItems="center"
          padding="xlarge"
        >
          <Box
            paddingX="large"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <Heading level="2">
              Step 2: Request a Reckon Portal text message
            </Heading>
            <Text size="medium">
              A Reckon Portal text message will be sent to the above number when
              you click Send Code
            </Text>
            <Box marginTop="small">
              <Button
                id="send-code"
                size="medium"
                block
                label="Send Code"
                onClick={() => sendCode()}
              />
            </Box>
            <Box marginTop="small" paddingY="large">
              <TextField
                type="text"
                label="Step 3: Enter code you received in the box below"
                {...form.fields.code.props}
              />
            </Box>
            {children}
            <Box marginTop="medium">
              <Button
                id="login"
                disabled={form.validity !== 'valid'}
                type="submit"
                size="medium"
                block
                label="Enabled MFA"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </Fragment>
  );
};
